import { paths } from './paths';
import OiIcon from './OiIcon';
export type OiIconPaths = keyof Readonly<typeof paths>;

export type IProps = {
  path: OiIconPaths;
  [key: string]: any;
};
export default OiIcon;
